import { MapPin, Clock, Hash, Instagram, ArrowUpRight } from "lucide-react";
import { MAPS_URL, INSTAGRAM_URL, MAPS_EMBED } from "./data";
import { Reveal, Eyebrow } from "./Reveal";

const INFO = [
  {
    icon: MapPin,
    label: "Address",
    value: "Apple mart, opp. kadri naturals, Mallikatte, Kadri, Mangaluru, Karnataka 575002",
  },
  {
    icon: Clock,
    label: "Hours",
    value: "Open daily · 4:00 PM — 11:30 PM",
  },
  {
    icon: Hash,
    label: "Plus code",
    value: "VVH3+M3 Mangaluru, Karnataka",
  },
  {
    icon: Instagram,
    label: "Instagram",
    value: "@nuunkebabs.mlr",
  },
];

export default function Visit() {
  return (
    <section
      id="visit"
      className="py-28 md:py-40 border-t border-white/10"
      data-testid="visit-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal className="mb-16 md:mb-20">
          <Eyebrow className="mb-4">Find the smoke</Eyebrow>
          <h2 className="font-display font-semibold text-4xl md:text-6xl leading-tight">
            Mallikatte, Kadri.
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-16 items-start">
          <div>
            <div className="space-y-8">
              {INFO.map(({ icon: Icon, label, value }, i) => (
                <Reveal key={label} delay={i * 0.07}>
                  <div className="flex gap-5">
                    <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/15">
                      <Icon className="w-4 h-4 text-ember" />
                    </span>
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-dim/70">
                        {label}
                      </p>
                      <p className="mt-2 text-bone/90 leading-relaxed max-w-sm">
                        {value}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.3}>
              <div className="mt-12 flex flex-wrap gap-4">
                <a
                  href={MAPS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="visit-directions-btn"
                  className="inline-flex items-center gap-2 rounded-full bg-ember hover:bg-emberglow text-charcoal font-semibold text-sm tracking-widest uppercase px-8 py-4 transition-all duration-300 hover:-translate-y-0.5"
                >
                  Get directions
                  <ArrowUpRight className="w-4 h-4" />
                </a>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="visit-instagram-btn"
                  className="inline-flex items-center gap-2 rounded-full border border-white/25 hover:border-gold text-bone font-medium text-sm tracking-widest uppercase px-8 py-4 transition-all duration-300 hover:-translate-y-0.5"
                >
                  <Instagram className="w-4 h-4 text-gold" />
                  Follow us
                </a>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="rounded-2xl overflow-hidden border border-white/10">
              <iframe
                data-testid="visit-map-iframe"
                title="Nuun Kebabs on Google Maps"
                src={MAPS_EMBED}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="map-dark w-full h-[380px] md:h-[460px]"
              />
            </div>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.22em] text-dim/60">
              Opposite Kadri Naturals · Beside Apple Mart
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
